import * as C from "react";
import { forwardRef as r } from "react";
const l = r(function(e, o) {
  return /* @__PURE__ */ C.createElement(
    "svg",
    {
      fill: "none",
      ref: o,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ C.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M13.1692 4C10.2017 4.20825 8.83077 5.16271 8.15401 5.63128C7.49456 6.09978 6.50543 7.00217 5.88073 7.81781C6.26249 8.11281 6.92193 8.59869 7.66813 8.85901C8.83077 9.27552 10.7917 9.37964 10.8091 9.37964L11.5553 9.41433L9.71585 13.5098L9.45553 13.5618C9.3514 13.5792 6.83512 14.0303 5.79391 14.0303C5.06509 14.0303 3.78095 13.8221 3.20825 13.718C3.03469 14.6898 3 15.6269 3 16.4425C3 17.8308 3.13881 18.82 3.13881 18.82C3.13881 18.82 5.82867 18.1431 8.50108 18.1431L17.1605 18.4381C17.1605 18.4381 20.77 14.3254 20.77 10.3688C20.77 9.62258 20.6486 8.87639 20.3362 8.16487C18.5488 4.17357 14.1063 4 13.308 4C13.2213 4 13.1692 4 13.1692 4ZM9.00434 12.59L10.0282 10.334C9.29934 10.2647 8.15401 10.1085 7.32106 9.83084C6.47074 9.51846 5.72454 9.0152 5.27335 8.63345C4.99565 9.04988 4.71803 9.4837 4.44033 9.95227C3.95445 10.8026 3.60738 11.757 3.39913 12.7289C3.95445 12.8329 5.15184 13.0239 5.79391 13.0239C6.55749 13.0239 8.32758 12.7289 9.00434 12.59ZM13.3948 12.1562C12.6139 12.1562 11.9544 11.5141 11.9544 10.7158C11.9544 9.91759 12.6139 9.27552 13.3948 9.27552C14.193 9.27552 14.8525 9.91759 14.8525 10.7158C14.8525 11.5141 14.193 12.1562 13.3948 12.1562Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  l as MotorRacing
};
